import React, { useEffect, useState } from "react";
import { ArrowUpRight, Layers3 } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import axios from "axios";
import { Link } from "react-router-dom";

function ProjectSection() {
  const [caseStudies, setCaseStudies] = useState([]);

  const fetchData = async () => {
    try {
      const res = await axios.get(
        "https://goawin.xyz/api/domain/case-studies",
        { withCredentials: true },
      );

      setCaseStudies(res.data.data || res.data.caseStudies || []);
    } catch (err) {
      console.log("Server Error");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <section className="relative py-16 md:py-16 px-4 sm:px-6 lg:px-16 overflow-hidden bg-white dark:bg-[#050505]">
      {/* BACKGROUND */}
      <div className="absolute top-0 left-0 w-[300px] md:w-[500px] h-[300px] md:h-[500px] bg-primary/10 blur-[120px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[300px] md:w-[500px] h-[300px] md:h-[500px] bg-primary/10 blur-[120px] rounded-full" />

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* HEADER */}
        <div className="text-center mb-10 md:mb-14 px-2">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary/20 bg-primary/10 text-primary text-xs md:text-sm font-semibold">
            Our Projects
          </span>

          <h2 className="mt-5 text-3xl md:text-6xl font-black text-gray-900 dark:text-white leading-tight">
            Creative Digital
            <span className="block bg-gradient-to-r from-primary via-orange-400 to-yellow-400 bg-clip-text text-transparent">
              Case Studies
            </span>
          </h2>

          <p className="myparagraph  max-w-2xl mx-auto text-gray-600 dark:text-gray-400">
            Explore modern websites, dashboards and digital experiences.
          </p>
        </div>

        {/* SWIPER */}
        <Swiper
          slidesPerView={"auto"}
          centeredSlides={true}
          spaceBetween={15}
          loop={true}
          speed={1000}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          className="pb-8"
        >
          {caseStudies.map((project, index) => (
            <SwiperSlide
              key={index}
              className="!w-[90%] sm:!w-[80%] md:!w-[450px] lg:!w-[520px]"
            >
              {({ isActive }) => (
                <div
                  className={`group relative overflow-hidden rounded-2xl border border-white/10 bg-black/20 backdrop-blur-xl transition-all duration-500
                  ${isActive ? "scale-100 md:scale-105" : "scale-95 opacity-90"}`}
                >
                  {/* IMAGE */}
                  <div className="relative h-[200px] sm:h-[260px] md:h-[320px] overflow-hidden">
                    <img
                      src={`https://goawin.xyz/${project.featuredImage}`}
                      alt={project.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition duration-700"
                    />

                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
                  </div>

                  {/* CONTENT */}
                  <div className="absolute bottom-0 left-0 w-full p-4 md:p-6">
                    <h3 className="text-sm md:text-2xl font-bold text-white">
                      {project.title}
                    </h3>

                    <p className="mt-2 text-xs md:text-sm text-white/70 line-clamp-2">
                      {project.shortDescription}
                    </p>

                    <Link
                      to={`https://webxsecure.in/case-study/${project.slug}`}
                      target="_blank"
                      className="mt-3 md:mt-4 inline-flex items-center gap-2 px-2 md:px-4 py-1 md:py-2 rounded md:rounded-lg bg-primary text-white text-xs md:text-sm font-semibold hover:gap-3 transition-all"
                    >
                      Go Project
                      <ArrowUpRight className="w-4 h-4" />
                    </Link>
                  </div>
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default ProjectSection;
